import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CtaProvider } from "@/components/landing/CtaProvider";
import { SmoothScroll, scrollToSection } from "@/components/landing/SmoothScroll";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { BeforeAfter } from "@/components/landing/BeforeAfter";
import { Benefits } from "@/components/landing/Benefits";
import { Gallery } from "@/components/landing/Gallery";
import { Emotional } from "@/components/landing/Emotional";
import { FinalCta } from "@/components/landing/FinalCta";
import { Footer } from "@/components/landing/Footer";
import LegalPage from "@/components/landing/LegalPage";
import { Timeline } from "@/components/landing/Timeline";
import { ConsentProvider } from "@/components/landing/ConsentProvider";
import { StoryHelper } from "@/components/landing/StoryHelper";
import { Pricing } from "@/components/landing/Pricing";
import { ChatWidget } from "@/components/landing/ChatWidget";
import PaymentResult from "@/components/landing/PaymentResult";
import AdminLeads from "@/components/landing/AdminLeads";
import { StickyMobileCta } from "@/components/landing/StickyMobileCta";
import { SHOW_PRICING } from "@/config/cta";
import { trackPageView } from "@/lib/tracking";
import { captureAttribution } from "@/lib/attribution";

captureAttribution();

const PageViews = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const t = setTimeout(() => trackPageView(pathname), 300);
    return () => clearTimeout(t);
  }, [pathname]);
  return null;
};

const HOME_TITLE = "KeepThis! — Save Kids' Artwork & Childhood Memories";

const Home = () => {
  const { hash } = useLocation();
  useEffect(() => {
    document.title = HOME_TITLE;
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }
    const t = setTimeout(() => scrollToSection(hash.slice(1)), 400);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <>
      <Nav />
      <main id="main" className="overflow-x-clip">
        <Hero />
        <Marquee />
        <HowItWorks />
        <BeforeAfter />
        <Benefits />
        <Gallery />
        <Timeline />
        <StoryHelper />
        <Emotional />
        {SHOW_PRICING && <Pricing />}
        <FinalCta />
      </main>
      <Footer />
      <StickyMobileCta />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <CtaProvider>
        <ConsentProvider>
        <SmoothScroll />
        <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-navy focus:px-4 focus:py-2 focus:text-cream">Skip to content</a>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<LegalPage slug="privacy" />} />
          <Route path="/terms" element={<LegalPage slug="terms" />} />
          <Route path="/cookies" element={<LegalPage slug="cookies" />} />
          <Route path="/payment/success" element={<PaymentResult />} />
          <Route path="/payment/cancel" element={<PaymentResult canceled />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <PageViews />
        <ChatWidget />
        </ConsentProvider>
      </CtaProvider>
    </BrowserRouter>
  );
}

export default App;
